export default "__VITE_ASSET__45fa192b__"